import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import { IContestEntry } from 'protos'

import List from '@material-ui/core/List'

import EventRankingItem from 'components/EventRankingItem'

const entries: Array<IContestEntry & { isDropdownActive?: boolean }> = [{
  user: {
    name: 'Disabled',
  },
}, {
  user: {
    userId: 'with-user-and-no-avatar',
    name: 'With User & No Avatar',
  },
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-user-and-avatar',
    name: 'With User & Avatar',
  },
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-score',
    name: 'With Score',
  },
  score: 183,
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-rank',
    name: 'With Rank',
  },
  score: 183,
  rank: 4,
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-prize',
    name: 'With Prize',
  },
  score: 183,
  rank: 4,
  prize: [ { money: { currency: 0, value: 100 } } ],
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-delta-up',
    name: 'With Delta Up',
  },
  score: 183,
  rank: 4,
  rankDelta: 1,
  prize: [ { money: { currency: 0, value: 100 } } ],
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-delta-down',
    name: 'With Delta Down',
  },
  score: 183,
  rank: 4,
  rankDelta: -1,
  prize: [ { money: { currency: 0, value: 100 } } ],
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'with-rank-badge',
    name: 'With Rank Badge',
  },
  score: 193,
  rank: 1,
  rankDelta: 1,
  prize: [ { money: { currency: 0, value: 100 } } ],
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'closed-details',
    name: 'Closed Details',
  },
  score: 193,
  rank: 2,
  prize: [ { money: { currency: 0, value: 100 } } ],
  details: [ { } ],
}, {
  user: {
    photoUrl: 'https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg',
    userId: 'opened-details',
    name: 'Opened Details',
  },
  score: 193,
  rank: 3,
  prize: [ { money: { currency: 0, value: 100 } } ],
  details: [{
    live: true,
    match: { awayTeam: { name: 'Manchester United' }, homeTeam: { name: 'Chelsea' } },
    score: 43,
  }, {
    live: false,
    match: { awayTeam: { name: 'BVB' }, homeTeam: { name: 'Hertha' } },
    score: 50,
  }, {
    live: false,
    match: { awayTeam: { name: 'Újpest FC' }, homeTeam: { name: 'Ferencváros FC' } },
    score: 100,
  }],
  isDropdownActive: true,
}]

storiesOf('EventRankingItem', module)
  .add('default', () => (
    <List style={{ padding: 0 }}>
      {entries.map(({isDropdownActive, ...entry}, i) => (
        <EventRankingItem
          key={`item-${i}`}
          entry={entry}
          onClick={action('onClick')}
          onClickAvatar={action('onClickAvatar')}
          isDropdownActive={isDropdownActive}
        />
      ))}
    </List>
  ))
